import { CreekWater } from "./CreekWater";
import { TornEdge } from "./TornEdge";

export function BuiltForSection() {
  return (
    <section className="relative isolate overflow-hidden py-28 md:py-40">
      <TornEdge position="top" color="#F5EFE2" />
      <TornEdge position="bottom" color="#F5EFE2" />
      <CreekWater />

      <div className="relative z-10 mx-auto max-w-[1000px] px-6 text-center">
        <h2 className="font-heading text-4xl font-black uppercase leading-[1.05] tracking-tight text-[#F5EFE2] [text-shadow:0_2px_18px_rgba(10,26,24,0.55)] sm:text-5xl md:text-6xl lg:text-7xl">
          PREMIUM SPORTING HEADWEAR
        </h2>
        <p className="mx-auto mt-8 max-w-xl font-body text-lg leading-relaxed tracking-wide text-[#F5EFE2]/70 md:text-xl">
          Wear something you stand for.
        </p>
      </div>
    </section>
  );
}
